import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { TBillingBundleSaleDependency } from './types';

export function useBillingBundleDependencies(bundleId: string | null) {
  const { data, error, isLoading, mutate } = useSWR<{
    dependencies: TBillingBundleSaleDependency[];
  }>(
    bundleId
      ? `commenda-billing/catalog/bundles/${bundleId}/sale-dependencies`
      : null,
    SWRFetcher({ method: 'GET' })
  );
  return { dependencies: data?.dependencies ?? [], error, isLoading, mutate };
}
